import { render } from "./TransactionsTableMobile.vue?vue&type=template&id=a2cac06e&scoped=true"
import script from "./TransactionsTableMobile.vue?vue&type=script&lang=js"
export * from "./TransactionsTableMobile.vue?vue&type=script&lang=js"

import "./TransactionsTableMobile.vue?vue&type=style&index=0&id=a2cac06e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2cac06e"]])

export default __exports__